import { useState, useEffect, useRef } from "react";
import { getDesktopTranslateX } from "../utils/carouselUtils";

export default function useDesktopCarousel(activeIndex, videosLength) {
  const [containerDimensions, setContainerDimensions] = useState({
    width: 0,
    height: 0,
  });
  const desktopContainerRef = useRef(null);

  // Track container dimensions for responsive calculations
  useEffect(() => {
    const updateDimensions = () => {
      if (desktopContainerRef.current) {
        const rect = desktopContainerRef.current.getBoundingClientRect();
        setContainerDimensions({ width: rect.width, height: rect.height });
      }
    };

    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const translateX = getDesktopTranslateX(
    activeIndex,
    containerDimensions.width,
    videosLength,
  );

  return {
    desktopContainerRef,
    containerDimensions,
    translateX,
  };
}
